import React, {useState, useEffect, Fragment } from 'react';
import { 
        Button,
        CircularProgress,
        Divider,
        Fab,
        Grid,
        InputAdornment,
        Paper,
        TextField,
        Tooltip,
        withWidth
        } from '@material-ui/core';
import { 
            AlarmOn as AlarmOnIcon,
            AttachMoney as AttachMoneyIcon,
            Block as BlockIcon,
            RemoveCircle as RemoveCircleIcon,
            Save as SaveIcon,

        } from '@material-ui/icons';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useAuth } from "../Auth";
import Swal from 'sweetalert2';
import { Alert } from '@material-ui/lab';
import '../../node_modules/antd/dist/antd.css';
import { Switch, Tooltip as TooltipAntd } from 'antd';
import {ScrollbarWrapper, Content} from "../Elementos/ContainerYounet"


function Tareas({widthWin}){
    const { authTokens, setRuta } = useAuth(); 
    const { enqueueSnackbar } = useSnackbar();
    const [ isProcessingA, setProcessingA ] = useState(false);
    const [ isProcessingB, setProcessingB ] = useState(false);
    const [ isProcessingC, setProcessingC ] = useState(false);
    const [ getValCronNotificaciones, setValCronNotificaciones ] = useState({});
    const [ getValCronCortes, setValCronCortes ] = useState({});
    const [ getValCronCortesMonthBack, setValCronCortesMonthBack ] = useState({});


    useEffect(()=>{
        const handleTareas = async()=>{
            setRuta('/Conf/Tareas');
            const fetchomeworks = await fetch('/api/tareas');
            const allhomeworks_ = await fetchomeworks.json();
            const allhomeworks = allhomeworks_.filter(el=> el.Empresa === authTokens.Empresa)
            for(const x in allhomeworks){
                switch(allhomeworks[x].Nombre){
                    case 'NOTIFICACION':
                        setValCronNotificaciones(allhomeworks[x]);
                        break;
                    case 'CORTES':
                        setValCronCortes(allhomeworks[x]);
                        break;
                    case 'CORTESMB':
                        setValCronCortesMonthBack(allhomeworks[x]);
                        break;
                    default:
                        console.log('NO APLICA');
                        break;
                }
            };
            
        };

        handleTareas();
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    
    const handleNotificaciones = ()=>{
        setProcessingA(true);
        fetch('/api/homeworks/notificaciones',{ method:'POST', body: JSON.stringify({Empresa:authTokens.Empresa}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, { variant:'success' });
                setTimeout(()=>{
                    setProcessingA(false);
                },1000);
            }else{
                enqueueSnackbar(result.status, { variant:'error' });
                setTimeout(()=>{
                    setProcessingA(false);
                },1000);
            }
        })
        
    };

    const handleCortes = async ()=>{
        setProcessingB(true);
        fetch('/api/homeworks/cortes',{ method:'POST', body: JSON.stringify({Empresa:authTokens.Empresa}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, { variant:'success' });
                setTimeout(()=>{
                    setProcessingB(false);
                },1000);
            }else{
                enqueueSnackbar(result.status, { variant:'error' });
                setTimeout(()=>{
                    setProcessingB(false);
                },1000);
            }
        });
    };

    const handleCortesMonthBack = async ()=>{
        setProcessingC(true);
        fetch('/api/homeworks/cortesMonthBack',{ method:'POST', body: JSON.stringify({Empresa:authTokens.Empresa}), headers:{'Content-Type': 'application/json'}}) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, { variant:'success' });
                setTimeout(()=>{
                    setProcessingC(false);
                },1000);
            }else{
                enqueueSnackbar(result.status, { variant:'error' });
                setTimeout(()=>{
                    setProcessingC(false);
                },1000);
            }
        });
        
    };

    const handleCronNotificaciones = ({target})=>{ setValCronNotificaciones({...getValCronNotificaciones, cronEjecutar:target.value}) };

    const handleCronCortes = ({target})=>{ setValCronCortes({...getValCronCortes, cronEjecutar:target.value}) };
    
    const handleCronCortesMonthBack = ({target})=>{ setValCronCortesMonthBack({...getValCronCortesMonthBack, cronEjecutar:target.value}) };

    const handleActiveNotificaciones = (checked)=>{ setValCronNotificaciones({...getValCronNotificaciones, isActive:checked}) };

    const handleActiveCortes = (checked)=>{ setValCronCortes({...getValCronCortes, isActive:checked}) };

    const handleActiveCortesMonthBack = (checked)=>{ setValCronCortesMonthBack({...getValCronCortesMonthBack, isActive:checked}) };

    const handleSaveNotificaciones = ()=>{
        Swal.fire({
            title:'DESEA GUARDAR LA INFORMACION',
            icon:'info',
            confirmButtonText:'SI',
            denyButtonText:'NO',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonColor:'#005596',
            width:600
        }).then(resServ=>{
            if(resServ.isConfirmed){
                fetch('/api/tareas',{
                    method:'PUT',
                    body: JSON.stringify(getValCronNotificaciones),
                    headers:{'Content-Type': 'application/json'}
                }) 
                .then(response=> response.json())
                .then((result) =>{
                    Swal.fire({
                        title:result.message ? result.message : result.status,
                        icon:result.message ? 'success' : 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:500
                    })
                })
            }
        })
    };

    const handleSaveCortes = ()=>{
        Swal.fire({
            title:'DESEA GUARDAR LA INFORMACION',
            icon:'info',
            confirmButtonText:'SI',
            denyButtonText:'NO',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonColor:'#005596',
            width:600
        }).then(resServ=>{
            if(resServ.isConfirmed){
                fetch('/api/tareas',{
                    method:'PUT',
                    body: JSON.stringify(getValCronCortes),
                    headers:{'Content-Type': 'application/json'}
                }) 
                .then(response=> response.json())
                .then((result) =>{
                    Swal.fire({
                        title:result.message ? result.message : result.status,
                        icon:result.message ? 'success' : 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:500
                    })
                })
            }
        })
    };

    const handleSaveCortesMonthBack = ()=>{
        Swal.fire({
            title:'DESEA GUARDAR LA INFORMACION',
            icon:'info',
            confirmButtonText:'SI',
            denyButtonText:'NO',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonColor:'#005596',
            width:600
        }).then(resServ=>{
            if(resServ.isConfirmed){
                fetch('/api/tareas',{
                    method:'PUT',
                    body: JSON.stringify(getValCronCortesMonthBack),
                    headers:{'Content-Type': 'application/json'}
                }) 
                .then(response=> response.json())
                .then((result) =>{
                    Swal.fire({
                        title:result.message ? result.message : result.status,
                        icon:result.message ? 'success' : 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        width:500
                    })
                })
            }
        })
    };

    const handleSms = (checked)=>{ setValCronNotificaciones({...getValCronNotificaciones, isSms:checked}) };

    const handleMail = (checked)=>{ setValCronNotificaciones({...getValCronNotificaciones, isMail:checked}) };

    const handleSmsCortes = (checked)=>{ setValCronCortes({...getValCronCortes, isSms:checked}) };

    const handleMailCortes = (checked)=>{ setValCronCortes({...getValCronCortes, isMail:checked}) }; 

    const handleSmsCortesMonthBack = (checked)=>{ setValCronCortesMonthBack({...getValCronCortesMonthBack, isSms:checked}) };

    const handleMailCortesMonthBack = (checked)=>{ setValCronCortesMonthBack({...getValCronCortesMonthBack, isMail:checked}) };

    const handleExecuteWeekend = (checked) => { setValCronCortes({...getValCronCortes, executeWeekend:checked})};

    const handleExecuteHolidays = (checked) => { setValCronCortes({...getValCronCortes, executeHolidays:checked})};

    const handleReconexion = (checked) => { setValCronCortes({...getValCronCortes, isReconexion:checked})};

    const handleExecuteWeekendMonthBack = (checked) => { setValCronCortesMonthBack({...getValCronCortesMonthBack, executeWeekend:checked})};

    const handleExecuteHolidaysMonthBack = (checked) => { setValCronCortesMonthBack({...getValCronCortesMonthBack, executeHolidays:checked})};

    return(
        <Grid container spacing={1} style={{width:'100%'}} justifyContent='center' alignItems='center'>
            <Grid item lg={6} md={8} sm={12} xs={12} style={{alignSelf: 'flex-start', padding:5}}>
                <Paper elevation={3} style={{padding:10, width:'100%'}}>
                    <ScrollbarWrapper>
                        <Content>
                            <Grid container justifyContent='space-around' spacing={2} >
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item >
                                        <Tooltip placement='top' title='EJECUTAR NOTIFICACIONES'>
                                            <span>
                                            <Fab size='medium' variant="contained" color='primary' onClick={handleNotificaciones}>
                                                {isProcessingA ? <CircularProgress size={20} color='info'/> :  <AlarmOnIcon />}
                                            </Fab>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip placement='top' title='EJECUTAR CORTES'>
                                            <span>
                                            <Fab size='medium' variant="contained" color='primary'  onClick={handleCortes}>
                                                {isProcessingB ? <CircularProgress size={20} color='info'/> :  <BlockIcon />}
                                            </Fab>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item >
                                        <Tooltip placement='top' title='EJECUTAR CORTES MES PASADO'>
                                            <span>
                                            <Fab size='medium' variant="contained" color='primary' onClick={handleCortesMonthBack}>
                                                {isProcessingC ? <CircularProgress size={20} color='info'/> :  <RemoveCircleIcon />}
                                            </Fab>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item xs={4}>
                                        <Tooltip placement='top' title='EJECUTAR NOTIFICACIONES'>
                                            <span>
                                            <Button fullWidth size='large' variant="contained" color='primary' endIcon={isProcessingA ? <CircularProgress size={20} color='info'/> :  <AlarmOnIcon />} onClick={handleNotificaciones}>
                                                NOTIFICACIONES
                                            </Button>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Tooltip placement='top' title='EJECUTAR CORTES'>
                                            <span>
                                            <Button fullWidth size='large' variant="contained" color='primary' endIcon={isProcessingB ? <CircularProgress size={20} color='info'/> :  <BlockIcon />} onClick={handleCortes}>
                                                CORTES
                                            </Button>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Tooltip placement='top' title='EJECUTAR CORTES MES PASADO'>
                                            <span>
                                            <Button fullWidth size='large' variant="contained" color='primary' endIcon={isProcessingC ? <CircularProgress size={20} color='info'/> :  <RemoveCircleIcon />} onClick={handleCortesMonthBack}>
                                                CORTES PASADOS
                                            </Button>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                </Fragment>
                            }
                            </Grid>
                        </Content>
                        <Content>
                            <Grid container spacing={1} justifyContent='space-between'>
                                <Grid item xs={12}>
                                    <Grid container justifyContent='space-between' spacing={1}>
                                        <Grid item xs={10}>
                                            <Alert severity={getValCronNotificaciones.isActive ? 'success' : "info" }><b>NOTIFICACIONES</b></Alert> 
                                        </Grid>
                                        <Grid item xs={2} style={{alignSelf:'center', display:'grid', placeContent:'center'}}>
                                            <TooltipAntd title="ACTIVAR NOTIFICACIONES" color='purple' >
                                                <Switch checkedChildren="ON" unCheckedChildren="OFF" checked={getValCronNotificaciones.isActive} onChange={handleActiveNotificaciones} />
                                            </TooltipAntd>
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid item lg={2} md={4} xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center', alignContent:'center'}}>
                                    <TextField
                                        value={getValCronNotificaciones.cronEjecutar}
                                        onChange={handleCronNotificaciones}
                                        type='time'
                                        margin='dense'
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item sm={1} xs={2} style={{alignSelf:'center'}}>
                                    <TooltipAntd title="SMS" color='pink' >
                                        <Switch checkedChildren="SMS" unCheckedChildren="SMS" checked={getValCronNotificaciones.isSms} onChange={handleSms} />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item sm={1} xs={2} style={{alignSelf:'center'}}>
                                    <TooltipAntd title="MAIL" color='pink' >
                                        <Switch checkedChildren="MAIL" unCheckedChildren="MAIL" checked={getValCronNotificaciones.isMail} onChange={handleMail} />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item md={3} xs={12}>
                                    <Tooltip placement='top' title='GUARDAR CAMBIOS'>
                                        <span>
                                        <Button fullWidth size='medium' variant="contained" color='secondary' endIcon={isProcessingA ? <CircularProgress size={20} color='info'/> :  <SaveIcon />} onClick={handleSaveNotificaciones}>
                                            GUARDAR
                                        </Button>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={12}>
                                <Alert severity="info">
                                    <span> <b>Ultima Ejecucion Manual:</b>   {getValCronNotificaciones.UltimaEjecucion} </span> &nbsp; &nbsp;
                                    <span> <b>Ejecucion Automática:</b> {getValCronNotificaciones.lastExecute} </span>
                                </Alert>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                            </Grid>
                        </Content>
                        <Content style={{marginTop:30}}>
                            <Grid container spacing={1} justifyContent='space-between'>
                                <Grid item xs={12}>
                                    <Grid container justifyContent='space-between' spacing={1}>
                                        <Grid item xs={10}>
                                            <Alert severity={getValCronCortes.isActive ? 'success' : "info" }><b>CORTES</b></Alert> 
                                        </Grid>
                                        <Grid item xs={2} style={{alignSelf:'center', display:'grid', placeContent:'center'}}>
                                            <TooltipAntd title="ACTIVAR CORTES" color='purple' >
                                                <Switch checkedChildren="ON" unCheckedChildren="OFF" checked={getValCronCortes.isActive} onChange={handleActiveCortes} />
                                            </TooltipAntd>
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid item lg={2} md={4} xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center', alignContent:'center'}}>
                                    <TextField
                                        value={getValCronCortes.cronEjecutar}
                                        onChange={handleCronCortes}
                                        type='time'
                                        margin='dense'
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item lg={1} md={2} xs={3} style={{alignSelf:'center', display:'grid', placeContent:'center', minHeight:50}}>
                                    <TooltipAntd title="SMS" color='pink' >
                                        <Switch checkedChildren="SMS" unCheckedChildren="SMS" checked={getValCronCortes.isSms} onChange={handleSmsCortes} />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item lg={1} md={2} xs={3} style={{alignSelf:'center', display:'grid', placeContent:'center', minHeight:50}}>
                                    <TooltipAntd title="MAIL" color='pink' >
                                        <Switch checkedChildren="MAIL" unCheckedChildren="MAIL" checked={getValCronCortes.isMail} onChange={handleMailCortes} />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item lg={2} md={2} xs={3} style={{alignSelf:'center', display:'grid', placeContent:'center', minHeight:50}}>
                                    <TooltipAntd title="EJECUTAR FINES DE SEMANA" color='pink' >
                                        <Switch checkedChildren="WEEKEND" unCheckedChildren="WEEKEND" checked={getValCronCortes.executeWeekend} onChange={handleExecuteWeekend} />
                                    </TooltipAntd>
                                </Grid>
                                
                                <Grid item lg={2} md={2} xs={3} style={{alignSelf:'center', display:'grid', placeContent:'center', minHeight:50}}>
                                    <TooltipAntd title="EJECUTAR EN FERIADOS" color='pink' >
                                        <Switch checkedChildren="HOLIDAYS" unCheckedChildren="HOLIDAYS" checked={getValCronCortes.executeHolidays} onChange={handleExecuteHolidays} />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item lg={1} md={2} xs={2} style={{alignSelf:'center', display:'grid', placeContent:'center', minHeight:50}}>
                                    <TooltipAntd title="COBRAR POR RECONEXION?" color='pink' >
                                        <Switch checkedChildren="SI" unCheckedChildren="NO" checked={getValCronCortes.isReconexion} onChange={handleReconexion} />
                                    </TooltipAntd>
                                </Grid>
                                {
                                    getValCronCortes.isReconexion &&
                                    <Grid item lg={2} md={4} xs={4} style={{display:'flex', justifyContent:'center', alignItems:'center', alignContent:'center'}}>
                                        <TooltipAntd title="VALOR POR RECONEXION" color='pink' >
                                            <TextField
                                                value={getValCronCortes.valReconexion}
                                                onChange={({target})=>{ setValCronCortes({...getValCronCortes, valReconexion:target.value})}}
                                                type='number'
                                                placeholder='Valor'
                                                margin='dense'
                                                fullWidth
                                                InputProps={{
                                                    startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AttachMoneyIcon />
                                                    </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </TooltipAntd>
                                    </Grid>

                                }
                                <Grid item lg={2} md={2} xs={12} >
                                    <Tooltip placement='top' title='GUARDAR CAMBIOS'>
                                        <span>
                                        <Button 
                                            fullWidth 
                                            size='medium' 
                                            variant="contained" 
                                            color='secondary' 
                                            endIcon={isProcessingB ? <CircularProgress  size={20} color='info'/> :  <SaveIcon />} 
                                            onClick={handleSaveCortes} 
                                            style={{marginTop:4}}>
                                            GUARDAR
                                        </Button>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={getValCronCortes.isReconexion && widthWin !=='xs' ? 10 : 12}>
                                <Alert severity="info">
                                    <span> <b>Ultima Ejecucion Manual:</b> {getValCronCortes.UltimaEjecucion} </span> &nbsp; &nbsp;
                                    <span> <b>Ejecucion Automática:</b> {getValCronCortes.lastExecute} </span>
                                </Alert>
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                            </Grid>
                        </Content>
                        <Content style={{marginTop:30}}>
                            <Grid container spacing={1} justifyContent='space-between'>
                                <Grid item xs={12}>
                                    <Grid container justifyContent='space-between' spacing={1}>
                                        <Grid item xs={10}>
                                            <Alert severity={getValCronCortesMonthBack.isActive ? 'success' : "info" }><b>CORTES MES PASADO</b></Alert> 
                                        </Grid>
                                        <Grid item xs={2} style={{alignSelf:'center', display:'grid', placeContent:'center'}}>
                                            <TooltipAntd title="ACTIVAR CORTES MES PASADO" color='purple' >
                                                <Switch checkedChildren="ON" unCheckedChildren="OFF" checked={getValCronCortesMonthBack.isActive} onChange={handleActiveCortesMonthBack} />
                                            </TooltipAntd>
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid item lg={2} md={4} xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center', alignContent:'center'}}>
                                    <TextField
                                        value={getValCronCortesMonthBack.cronEjecutar}
                                        onChange={handleCronCortesMonthBack}
                                        type='time'
                                        margin='dense'
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item sm={1} xs={2} style={{alignSelf:'center'}}>
                                    <TooltipAntd title="SMS" color='pink' >
                                        <Switch checkedChildren="SMS" unCheckedChildren="SMS" checked={getValCronCortesMonthBack.isSms} onChange={handleSmsCortesMonthBack} />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item sm={1} xs={2} style={{alignSelf:'center'}}>
                                    <TooltipAntd title="MAIL" color='pink' >
                                        <Switch checkedChildren="MAIL" unCheckedChildren="MAIL" checked={getValCronCortesMonthBack.isMail} onChange={handleMailCortesMonthBack} />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item lg={2} md={2} xs={3} style={{alignSelf:'center', display:'grid', placeContent:'center', minHeight:50}}>
                                    <TooltipAntd title="EJECUTAR FINES DE SEMANA" color='pink' >
                                        <Switch checkedChildren="WEEKEND" unCheckedChildren="WEEKEND" checked={getValCronCortesMonthBack.executeWeekend} onChange={handleExecuteWeekendMonthBack} />
                                    </TooltipAntd>
                                </Grid>
                                
                                <Grid item lg={2} md={2} xs={3} style={{alignSelf:'center', display:'grid', placeContent:'center', minHeight:50}}>
                                    <TooltipAntd title="EJECUTAR EN FERIADOS" color='pink' >
                                        <Switch checkedChildren="HOLIDAYS" unCheckedChildren="HOLIDAYS" checked={getValCronCortesMonthBack.executeHolidays} onChange={handleExecuteHolidaysMonthBack} />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item md={3} xs={12}>
                                    <Tooltip placement='top' title='GUARDAR CAMBIOS'>
                                        <span>
                                        <Button fullWidth size='medium' variant="contained" color='secondary' endIcon={isProcessingC ? <CircularProgress size={20} color='info'/> :  <SaveIcon />} onClick={handleSaveCortesMonthBack}>
                                            GUARDAR
                                        </Button>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={12}>
                                <Alert severity="info">
                                    <span> <b>Ultima Ejecucion Manual:</b> {getValCronCortesMonthBack.UltimaEjecucion}</span> &nbsp; &nbsp;
                                    <span> <b>Ejecucion Automática:</b> {getValCronCortesMonthBack.lastExecute}</span>
                                </Alert>
                                </Grid>
                            </Grid>
                        </Content>
                    </ScrollbarWrapper>  
                </Paper>
            </Grid>
            
        </Grid>
    );
};

function HomeWorks(props){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
          <Tareas widthWin={props.width}/>
        </SnackbarProvider>
    );
};

export default withWidth()(HomeWorks);